import { EnvironmentProviders } from '@angular/core';
import { provideAuditFieldDefinitions } from 'O3_audit';
import {
  FINANCIALS_AUDIT_DEFINITIONS,
  FINANCIALS_AUDIT_TRANSLATIONS,
} from 'O3_financials/audit';
import {
  PATHOLOGY_REQUEST_AUDIT_DEFINITIONS,
  PATHOLOGY_REQUEST_AUDIT_TRANSLATIONS,
} from 'O3_pathological-anatomy';
import {
  APPOINTMENT_AUDIT_DEFINITIONS,
  APPOINTMENT_AUDIT_TRANSLATIONS,
} from 'O3_scheduler/audit';
import {
  SYSTEM_CATALOG_AUDIT_DEFINITIONS,
  SYSTEM_CATALOG_AUDIT_TRANSLATIONS,
} from 'O3_system-catalogs';

/**
 * Aggregates audit field definitions and translations from all domain modules
 * for the global audit log view (/audit/audit-log/list).
 *
 * When a new module adds audit support, add its provideAuditFieldDefinitions() call here.
 */
export const GLOBAL_AUDIT_PROVIDERS: EnvironmentProviders[] = [
  provideAuditFieldDefinitions(
    PATHOLOGY_REQUEST_AUDIT_DEFINITIONS,
    PATHOLOGY_REQUEST_AUDIT_TRANSLATIONS,
  ),
  provideAuditFieldDefinitions(
    SYSTEM_CATALOG_AUDIT_DEFINITIONS,
    SYSTEM_CATALOG_AUDIT_TRANSLATIONS,
  ),
  provideAuditFieldDefinitions(
    APPOINTMENT_AUDIT_DEFINITIONS,
    APPOINTMENT_AUDIT_TRANSLATIONS,
  ),
  provideAuditFieldDefinitions(
    FINANCIALS_AUDIT_DEFINITIONS,
    FINANCIALS_AUDIT_TRANSLATIONS,
  ),
];
